import { EmployeeType, EmployeesResult, Params } from 'app/dataTypes/employeesList';
import type { Request } from '../../index';
import Person from 'app/common/classes/person';
import SimpleDate from 'app/common/classes/simple-date';


export type ApiParams = {
  search?: string,
  id?: number,
  limit?: number,
  offset?: number,
  role_id?: number,
  school_id?: number,
}

export type Employee = {
  id: number,
  name: {
    last?: string,
    first?: string,
    middle?: string,
  },
  photo?: string,
  birthdate?: string,
  phone?: string,
  email?: string,
  card?: string,
  invite_date?: string,
  gender?: 'male' | 'female',
  role_id?: number,
  role_title?: string,
  school_id?: number,
  school_title?: string,
}

export type EmployeesApi = {
  [id: string]: Employee,
}

export type EmployeesResultApi = {
  result: 'success',
  employees: EmployeesApi,
  count: number,
}

const apiDateFormat = 'YYYY-MM-DD' as const

export const convertResult = (apiData: EmployeesResultApi): EmployeesResult => {
  const { employees, count } = apiData
  const res = Object.values(employees).map(employee => {
    const {
      id,
      name,
      photo,
      birthdate,
      phone,
      email,
      card,
      invite_date: inviteDate,
      gender,
      role_id: roleId,
      role_title: roleTitle,
      school_id: schoolId,
      school_title: schoolTitle,
    } = employee
    return {
      id: id.toString(),
      person: new Person({ ...name, gender }),
      name,
      photo,
      birthdate: birthdate ? new SimpleDate(birthdate, apiDateFormat) : null,
      phone,
      email,
      card,
      inviteDate: inviteDate ? new SimpleDate(inviteDate, apiDateFormat) : null,
      roleId,
      roleTitle,
      schoolId,
      schoolTitle
    } as EmployeeType
  })

  return {
    employees: res,
    count
  }
}

export const convertParams = (params: Params): [ApiParams, null] => {
  const {
    search,
    id,
    limit,
    offset,
    roleId,
    schoolId
  } = params
  return [{
    search,
    id: id ? parseInt(id, 10) : undefined,
    limit,
    offset,
    role_id: roleId ? parseInt(roleId, 10) : undefined,
    school_id: schoolId ? parseInt(schoolId, 10) : undefined,
  }, null]
}

export const GET_EMPLOYEES_LIST: Request<Params, EmployeesResult, void> = [
  'food/employees',
  'get',
  ['data'],
];
